import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Mail, Printer } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { InvoicePaper } from "@/components/InvoicePaper";

export default function InvoicePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [inv, setInv] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    api.get(`/admin/orders/${id}/invoice`)
      .then(({ data }) => setInv(data))
      .catch((e) => toast.error(formatApiError(e)));
  }, [id]);

  const emailInvoice = async () => {
    setSending(true);
    try {
      await api.post(`/admin/orders/${id}/invoice/email`);
      toast.success("Invoice emailed to the customer");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(false);
    }
  };

  if (!inv)
    return (
      <div className="min-h-screen bg-[#FAF7F0] flex items-center justify-center">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E7B3A]">Loading…</p>
      </div>
    );

  return (
    <div className="min-h-screen bg-[#FAF7F0] py-10 px-4" data-testid="invoice-page">
      <style>{`@media print {
        body { background: #ffffff !important; }
        .no-print { display: none !important; }
        .invoice-paper { border: none !important; box-shadow: none !important; margin: 0 !important; max-width: 100% !important; width: 100% !important; }
      }`}</style>

      <div className="no-print max-w-3xl mx-auto mb-6 flex flex-wrap items-center justify-between gap-3">
        <button onClick={() => navigate(-1)} data-testid="invoice-back-button"
          className="flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#4A4A4A] hover:text-[#9E7B3A] transition-colors duration-300">
          <ArrowLeft className="w-4 h-4" /> Back
        </button>
        <div className="flex gap-3">
          <button onClick={() => window.print()} data-testid="invoice-print-button"
            className="flex items-center gap-2 border border-[#C5A059]/50 bg-white text-xs tracking-[0.2em] uppercase px-5 py-3 text-[#4A4A4A] hover:border-[#9E7B3A] hover:text-[#9E7B3A] transition-colors duration-300">
            <Printer className="w-4 h-4" /> Print / Save PDF
          </button>
          <button onClick={emailInvoice} disabled={sending} data-testid="invoice-email-button"
            className="flex items-center gap-2 bg-[#1A1A1A] text-white text-xs tracking-[0.2em] uppercase px-5 py-3 hover:bg-[#9E7B3A] disabled:opacity-50 transition-colors duration-300">
            <Mail className="w-4 h-4" /> {sending ? "Sending…" : "Email Invoice"}
          </button>
        </div>
      </div>

      <InvoicePaper inv={inv} />
    </div>
  );
}
